import React, { useState, useRef, useEffect } from "react";
import charactershot03 from '../Videos/CharacterShot03.mp4'
import charactershot04 from '../Videos/CharacterShot04.mp4'
import animation from '../Videos/animation.mp4'
import animation02 from '../Videos/animation 02.mp4'

export default function RoughAnimation() {

    var sectionStyle1 = 'iron ball.png'
    var sectionStyle2 = 'Untitled-4.png'
    var sectionStyle3 = 'Untitled-6.png'
    var sectionStyle4 = 'Untitled-7.png'
    var sectionStyle5 = 'Untitled-8.png'
    var sectionStyle6 = 'Untitled-9.png'
    var sectionStyle7 = 'Untitled-10.png'
    var sectionStyle8 = 'Untitled-11.png'
 

    var sections = [ sectionStyle1, sectionStyle2, sectionStyle3, sectionStyle4, sectionStyle5, sectionStyle6, sectionStyle7, sectionStyle8]

    const [toggle, setToggle] = useState(false)
    var [sectionStyle, setStyle] = useState("")

    
    
    return (
        <>
            <div className="parent">
                <div className="Rga" >
                    <a href="/"><button  className="left-slide"><img src="back_arrow.svg" /></button></a>
                    <img className="RgaTitle" src="Portfolio Fonts08.png"/>
                    <div class="container"> 
                        <div class="item"><video className="rgaAni" autoPlay muted loop><source src={charactershot03} type="video/mp4" ></source></video></div>
                        <div class="item"><video className="rgaAni" autoPlay muted loop><source src={charactershot04} type="video/mp4" ></source></video></div> 
                        <div class="item"><video className="rgaAni" autoPlay muted loop><source src={animation} type="video/mp4" ></source></video></div> 
                        <div class="item"><video className="rgaAni" autoPlay muted loop><source src={animation02} type="video/mp4" ></source></video></div> 
                    </div>
                </div>
            </div>
        </>
    );
}